import { Form } from '../../../../components/Form/Form'
import ImageUploader from '../../../../components/ImageUploader/ImageUploader'
import MultiSelect from '../../../../components/MultiSelect/MultiSelect'
import MultiSelectItem from '../../../../components/MultiSelect/MultiSelectItem'
import React from 'react'
import Select from '../../../../components/Select/Select'
import SelectItem from '../../../../components/Select/SelectItem'
import TextField from '../../../../components/TextField/TextField'
import t from '../../../../helpers/i18n'

const NewCompetitionStepOne = ({ divisions, events, data, setFormValid }) => {
  const currentDate = new Date()
  const seasonYear =
    currentDate.getFullYear() + (currentDate.getMonth() < 5 ? -1 : 0)

  return (
    <div>
      <h3>{t('titles.New_competition_General_Competition_Information')}</h3>
      <Form data={data} onValidityChange={setFormValid}>
        <TextField
          name='name'
          label={t('labels.Name')}
          maxLength={100}
          minLength={2}
          required
        />
        <ImageUploader name='logo' label={t('labels.Logo')} />
        <Select name='season' label={t('labels.Season')} required>
          {Array(12)
            .fill(0)
            .map((_, index) => {
              const year = seasonYear + index
              return (
                <SelectItem key={index} value={year}>
                  {year} - {year + 1}
                </SelectItem>
              )
            })}
        </Select>
        <MultiSelect name='divisions' label={t('labels.Division(s)')}>
          {divisions &&
            divisions.map((division) => (
              <MultiSelectItem
                key={division.division_id}
                value={division.division_id}
              >
                {division.name}
              </MultiSelectItem>
            ))}
        </MultiSelect>
        <Select name='event_id' label={t('labels.Multi_Competition_Events')}>
          <SelectItem>{t('select_item.Off')}</SelectItem>
          {events &&
            events.map((event) => (
              <SelectItem key={event.event_id} value={event.event_id}>
                {event.name}
              </SelectItem>
            ))}
        </Select>
      </Form>
    </div>
  )
}

export default NewCompetitionStepOne
